/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { NodesPage } from '@/pages/Nodes/NodesPage';

export function NodesRoute() {
  return <NodesPage />;
}
